export function arrayIncludesObject(
  array: any[],
  object: any,
  compareKey = 'name',
) {
  return array.some(arrayItem => arrayItem[compareKey] === object[compareKey]);
}
